<div class="" [hidden]="!isLoaded">

  <mat-toolbar class="no-background">
    <span>月報（損益率のみ）</span>
    <span class="spacer"></span>
  </mat-toolbar>

  <div>

    <span *ngIf="data">

      （{{updated}} 現在）　損益率は訂正される可能性があります。<br>

      <div style="padding-left: 0.7em; margin-top: 0.5em;">
      </div>

      <div class="table-wrapper" #tableWrapper>
        <table class="custom-table">
          <tr>
            <th class="sticky-col">POOL type</th>
            @for (ad of ads; track ad;) {
              <th>{{ym(ad)}}</th>
            }
          </tr>

          @for (type of poolTypes; track type;) {
            <tr>
              <th class="sticky-col">{{type}}</th>

              @for (ad of ads; track ad;) {
                <td style="text-align: right;" [ngClass]="{'negative': isNegativeProfit(ad, type)}">{{getProfit(ad, type)}}</td>
              }
            </tr>
          }

        </table>
      </div>

      ※損益率について、新システムの内部処理では小数点第8位の精度にて計算しておりますが、Web画面上では小数点第3位以下を切り捨てて表記しております。<br>

    </span>

  </div>

</div>

